import styled from 'styled-components';
import variables, { mq, fs, screenSize, isTouchMedia } from '../../utils/variables';

export const HeaderWrapper = styled.header`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  width: 100%;
  z-index: 1000;
`;

export const Container = styled.div`
  margin: 0 auto;
  padding: 1.45rem 5vw;

  ${mq('l')} {
    padding: 1.45rem 35px;
  }

  ${mq('s')} {
    padding: 1.45rem 20px;
  }

  ${screenSize('padding-top', 28)}
  ${screenSize('padding-bottom', 28)}
`;

export const LogoWrapper = styled.div`

  ${mq('m', true)} {
    svg {
      /* max-width: 11vw; */
      ${screenSize('width', 200)}
      ${screenSize('height', 58)}
    }
  }

  ${mq('m')} {
    svg {
      max-width: 143px;
    }
  }
`;

export const HeaderInner = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  z-index: 1010;
`;

export const NavigationListBase = styled.ul`
  display: flex;
  flex-direction: row;
  align-items: center;
  list-style-type: none;
  margin: 0;

  ${mq('xl')} {
    flex-direction: column;
  }

  ${mq('xl')} {
    align-items: flex-start;
  }
`;

export const NavigationLoginBase = styled.ul`
  display: flex;
  flex-direction: row;
  align-items: center;
  list-style-type: none;
  margin: 0;

  ${mq('xl')} {
    justify-content: flex-start;
    margin: 35px;
  }
`;

export const NavigationTopNav = styled.nav`
  display: flex;
  justify-content: flex-end;
  align-items: center;

  ${mq('xl')} {
    margin: 35px;
    justify-content: flex-start;
  }

  ${screenSize('margin-bottom', 15)}
`;

export const NavigationTopItem = styled.li`
  display: flex;
  position: relative;
  align-items: center;
  margin: 0 0 0 14px;
  padding: 0 0 0 18px;


  ${mq('xl')} {
    margin: 8px 0;
    padding-left: 0;
  }

  &:before {
    content: '';
    position: absolute;
    top: 50%;
    left: 0;
    transform: translate(0, -50%);
    width: 4px;
    height: 4px;
    background: grey;
    display: block;

    ${mq('xl')} {
      display: none;
    }
  }

  &:first-child {
    margin-left: 0;
    padding-left: 0;

    &:before {
      display: none;
    }
  }

  a {
    display: inline-block;
    color: ${props => props.dark ? variables.colors.grey : variables.colors.grey};
    font-weight: 600;
    text-decoration: none;
    text-transform: uppercase;
    letter-spacing: 2px;

    ${fs(12)}
    
    ${isTouchMedia()} {
      &:hover {
        color: ${variables.colors.red};
      }
    }
  }
`;

export const NavigationMainItem = styled.li`
  ${props => props.withSubMenu ? `position: relative;` : null}
  margin: 0 20px;

  ${mq('xl')} {
    position: relative;
    width: 100%;
    margin: 12px 0;
  }

  .icon-left {
      position: absolute;
      top: 0;
      right: 0;
    }

  a {
    position: relative;
    z-index: 1000;
    display: inline-block;
    color: ${props => props.dark ? (props.highlight ? variables.colors.green : variables.colors.white) : (props.highlight ? variables.colors.green : variables.colors.backgroundDark)};
    font-family: 'Bossa', sans-serif;
    font-weight: 500;
    line-height: 1.48;
    text-decoration: none;

    ${fs(16)}

    ${mq('xl')} {
      font-family: 'Montserrat', sans-serif;
      font-weight: 500;
    }

    ${mq('l')} {
      font-size: 18px;
    }

    ${mq('m')} {
      font-size: 17px;
    }

    ${mq('s')} {
      font-size: 14px;
    }

    &::after {
      content: '';
      position: absolute;
      display: ${props => props.active ? 'block' : 'none'};
      width: 100%;
      top: calc(100% + 10px);
      height: 2px;
      background: ${variables.colors.blue};

      ${mq('xl')} {
        top: calc(100% + 3px);
      }
    }

    .icon-svg {
      margin-left: 9px;

      ${props => props.opened ? `transform: rotateX(180deg);` : `transform: rotateX(0deg);`}

      path {
        fill: ${props => props.dark ? (props.highlight ? variables.colors.green : variables.colors.white) : (props.highlight ? variables.colors.green : variables.colors.black)};
      }
    }
    ${isTouchMedia()} {
      &:hover {
        color: ${variables.colors.red};

        .icon-svg {
          path {
            fill: ${variables.colors.red};
          }
        }
      }
    }
  }
`;

export const NavigationMainSubMenu = styled.div`
  position: absolute;
  /* z-index: ${props => props.visible ? '1005' : '-1'}; */
  /* width: calc(100% - 186px); */
  width: 39vw;
  left: 50%;
  top: 100%;
  transition: all .25s ease-in-out;

  transform: translate(-50%, ${props => props.visible ? '0' : '-100%'});
  padding: ${props => props.visible ? '10px' : '10px'} 0 0 0;
  opacity: ${props => props.visible ? '1' : '0'};
  pointer-events: ${props => props.visible ? 'all' : 'none'};
/* 
  transform: translate(-50%, 0);
  padding: 35px 0 0 0;
  opacity: 1;
  pointer-events: all; */

  .inner {
    position: absolute;
    width: 100%;
    margin: 0 auto;
    /* padding: 40px 45px; */
    border-radius: 8px;
    border: 1px solid ${variables.colors.greyLighter};
    box-shadow: -1px 9px 20px rgba(116, 116, 188, 0.25);
    background: ${variables.colors.white} none;
  }

  

  .list {
    list-style-type: none;
    padding: 12px 14px;
    margin: 0;
  }

  ul {
    li {
      position: relative;
      margin: 0;
      padding: 10px 0;

      &:first-child {
        padding-top: 0;
      }

      &:last-child {
        padding-bottom: 0;

        .link::before {
          display: none;
        }
      }
    }
  }

  .link {
    position: relative;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px 0;
    border-radius: 8px;

    &::before {
      content: '';
      position: absolute;
      display: block;
      width: 100%;
      height: 1px;
      bottom: -10px;
      left: 0;
      border-bottom: 1px dashed ${variables.colors.greyLight};
    }

    .text {
      display: block;
      flex: 1;
      padding: 0 30px 0 10px;
      color: ${variables.colors.backgroundDark};

      .title {
        display: block;
        font-family: 'Bossa', sans-serif;
        font-weight: 500;
        ${fs(16)}
      }

      .text-content {
        display: block;
        font-family: 'Montserrat', sans-serif;
        font-weight: 500;
        ${fs(14)}
      }
    }

    .icon-arrow {
      display: block;
      margin-right: 20px;
    }

    .icon {
      width: 42px;
      height: 42px;
      margin-left: 12px;

      path {
        fill: transparent;
        transition: all .8s ease-out;

        &.colorized {
          fill: ${variables.colors.backgroundDark};
        }
      }
    }
    
    &::after {
      display: none;
    }

    &:hover {
      background: ${variables.colors.greyLighter} none;

      .title {
        color: ${variables.colors.blue};
      }

      .icon-arrow {
        transform: translate(10px, 0);
      }

      svg .colorized-hover {
        fill: ${variables.colors.blue} !important;
      }
    }
  }

  .intro {
    display: flex;
    padding: 12px 14px;
    border-bottom: 1px solid ${variables.colors.greyLighter};

    .link::before {
      display: none;
    }

    .link {
      display: flex;
      width: 100%;
    }

    .link .icon {
      display: block;
      margin-left: 20px;
      width: 64px;
      height: 64px;
    }

    .text {
      display: block;
      flex: 1;
      /* padding: 0 40px; */
      color: ${variables.colors.backgroundDark};

      .title {
        ${fs(20)}
      }

      .text-content {
        ${fs(16)}
      }
    }
  }
`;

export const NavigationLoginItem = styled.li`
  margin: 0 10px;

  a {
    display: inline-block;
    color: ${variables.colors.red};
    font-family: 'Bossa', sans-serif;
    font-weight: 700;
    line-height: 1.48;
    text-decoration: none;

    ${fs(16)}
    
    ${isTouchMedia()} {
      &:hover {
        color: ${props => props.dark ? variables.colors.white : variables.colors.black};
      }
    }
  }
`

export const NavigationLoginItemButton = styled.li`
  margin: 0 0 0 10px;

  a {
    ${screenSize('height', 46)}
    ${screenSize('line-height', 46)}
    ${screenSize('padding-left', 28)}
    ${screenSize('padding-right', 28)}
    ${fs(16)}
  }
`

export const SubMenuIntro = styled.div`
  max-width: 370px;
  padding-bottom: 28px;

  h2 {
    font-family: 'Bossa', sans-serif;
    font-weight: 700;
    line-height: 27px;
    margin-bottom: 15px;

    ${fs(24)}
  }

  p {
    font-family: 'Montserrat', sans-serif;
    font-weight: 500;
    line-height: 1.5;

    ${fs(18)}
  }
`

export const ColsWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  margin: 0 -20px;
`;

export const Col = styled.div`
  width: 100%;
  margin: 0 20px;
`;

export const SectionTitle = styled.h3`
  display: flex;
  align-items: center;
  font-family: 'Bossa', sans-serif;
  font-weight: 500;
  margin-bottom: 20px;
  color: ${variables.colors.greyDark};

  ${fs(16)}

  &::after {
    content: '';
    width: calc(100% - 13px);
    margin-left: 13px;
    height: 1px;
    flex: 1;
    background: ${variables.colors.greyLighter};
  }
`;

export const Block = styled.div`
  padding: 0 28px 20px 0;
`;

export const BlockTitle = styled.h4`
  margin: 0 0 10px 0;
`;

export const BlockText = styled.div`
  p {

  }
`;

export const BurgerMenuTrigger = styled.button`
  position: relative;
  z-index: 20;
  border: 0;
  background: transparent none;
  outline: none;
  cursor: pointer;

  svg {
    path {
      fill: ${variables.colors.red};
      transition: all .2s;

      ${props => props.opened ? `
        &:nth-child(1) {
          transform: rotate(45deg) translate(calc(100% + 4px),-6px) scaleX(-1);
        }

        &:nth-child(2) {
          opacity: 0;
        }

        &:nth-child(3) {
          transform: rotate(-45deg) translate(-12px,-2px);
        }
      ` : null}
    }
  }

  ${isTouchMedia()} {
    &:hover {
      svg {
        path {
          fill: ${variables.colors.blue};
        }
      }
    }
  }
`;

export const BurgerMenu = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  overflow: auto;
  background: ${props => props.dark ? variables.colors.backgroundDark : variables.colors.white};
  opacity: 0;
  transition: opacity .7s;
  pointer-events: none;

  &.opened {
    opacity: 1;
    pointer-events: all;
  }
`;

export const BurgerMenuInner = styled.div`
  display: flex;
  min-height: 100%;
  flex-direction: column;
  justify-content: center;
  padding-top: 108px;
  

  > nav {
    text-align: left;
    margin: 0 35px 35px;

    ul {
      margin-left: 0;
      margin-right: 0;
    }
  }
`;